import {
  ConfigItem,
  ConfigItemType,
  ConfigItemValue,
  MultiCellConfigValue,
  MultiSelectConfigItem,
} from '@ecosystem/newron-client-lib';

import { ConfigItemCallbacks, ConfigItemsInfo, GetInsightInfoFn, InsightDataInfo } from '../../../shared/types';

import { StatsRendererData } from './StatsRenderer';

const defaultConfigItems: ConfigItem[] = [
  {
    key: 'user-type',
    label: 'User Type',
    type: ConfigItemType.MultiSelect,
    value: [],
    options: [
      { label: 'Client', value: 'client' },
      { label: 'Internal', value: 'internal' },
      { label: 'Proxy', value: 'proxy' },
    ],
  },
];

const getConfigItems = ({ data }: { data: StatsRendererData }): ConfigItemsInfo => {
  const configItems = defaultConfigItems.map(item => {
    if (item.key === 'user-type') {
      return {
        ...item,
        value: data.userTypes?.map(type => ({ label: type, value: type })) || [],
      } as MultiSelectConfigItem;
    }
    return item;
  });

  return { configItems };
};

const getInsightData = ({
  data,
  configItems,
}: {
  data: StatsRendererData;
  configItems: ConfigItem[];
}): InsightDataInfo<StatsRendererData> => {
  const userTypesValue = configItems.find(item => item.key === 'user-type')?.value as MultiCellConfigValue;
  const userTypes = userTypesValue?.map(val => val.value);

  return {
    data: {
      ...data,
      userTypes,
    },
  };
};

const applyConfigValue = ({
  configItems,
  newValue,
}: {
  data: StatsRendererData;
  configItems: ConfigItem[];
  newValue: ConfigItemValue;
}): ConfigItemsInfo => {
  const adjustedConfigItems = configItems.map(item => {
    if (item.key === newValue.key) {
      return { ...item, value: newValue.value } as ConfigItem;
    }
    return item;
  });

  return { configItems: adjustedConfigItems };
};

const clearConfigValues = (): ConfigItemsInfo => {
  return {
    configItems: defaultConfigItems,
  };
};

export const configItemCallbacks: ConfigItemCallbacks<StatsRendererData> = {
  getConfigItems,
  getInsightData,
  applyConfigValue,
  clearConfigValues,
  // getViewStateInfo,
  // applyMultiEditConfigValue,
};

export const getInsightInfo: GetInsightInfoFn<StatsRendererData> = data => ({
  tags: data.userTypes?.map(u => ({ key: 'User Type', value: u })),
  chartName: data.type,
});
